import styled from 'styled-components';
import { motion } from 'framer-motion';

export const HomeContainer = styled(motion.div)`
  width: 100%;
  min-height: 100vh;
  background: white;
`;

